@if (justification(); as justification) {
	<details class="auto-graded-justification" data-cy="auto-graded-score-justification">
		<summary class="auto-graded-justification__summary">
			<div class="score-justification-text">
				<span class="auto-graded-justification-arrow"></span>
				<span class="auto-graded-justification__title">
					{{ 'rubric-feedback-viewer_score-justification' | translate }}
				</span>
			</div>
			@if(element().type !== 'text') {
				<span class="auto-graded-justification__status">
					<span
						class="auto-graded-justification__status-icon"
						[class.auto-graded-justification__status--increased]="status() === 'increased'"
						[class.auto-graded-justification__status--decreased]="status() === 'decreased'"
						aria-hidden="true">
						@switch (status()) {
							@case ('increased') { <i class="ficon-arrow-up"></i> }
							@case ('decreased') { <i class="ficon-arrow-down"></i> }
							@default { <i class="ficon-minus"></i> }
						}
					</span>
					{{ statusSummary() }}
				</span>
			}
		</summary>
		<div class="auto-graded-justification__content">
			<section>
				<h4><strong>{{ 'rubric-feedback-viewer_auto-grade-summary' | translate }}</strong></h4>
				<p class="preformatted">{{ justification.summary }}</p>
			</section>
			@if (evidence().length > 0) {
				<section>
					<h4><strong>{{ 'rubric-feedback-viewer_video-evidence' | translate }}</strong></h4>
					<dl class="auto-graded-justification__evidence">
						@for (item of evidence(); track $index) {
							<div>
								<dt>{{ formatTimestamp(item.timestamp_ms) }}</dt>
								<dd>{{ item.description }}</dd>
							</div>
						}
					</dl>
				</section>
			}
			@if (editable() || justification.instructor_comment != null) {
				<section>
					<h4><strong>{{ 'rubric-feedback-viewer_instructor-comment' | translate }}</strong></h4>
					@if (editable()) {
						<mat-form-field appearance="outline" class="auto-graded-justification__comment-field">
							<mat-label>{{ 'rubric-feedback-viewer_add-comment' | translate }}</mat-label>
							<textarea
								matInput
								cdkTextareaAutosize
								[errorStateMatcher]="validationErrorStateMatcher"
								[attr.aria-describedby]="validationError() ? validationErrorId() : null"
								[attr.data-score-override-error]="validationError() ? 'true' : 'false'"
								[ngModel]="justification.instructor_comment"
								(ngModelChange)="instructorCommentChange.emit($event)">
							</textarea>
							@if (validationError()) {
								<mat-error [id]="validationErrorId()">{{ validationError() }}</mat-error>
							}
						</mat-form-field>
					} @else {
						<p class="preformatted">{{ justification.instructor_comment }}</p>
					}
				</section>
			}
		</div>
	</details>
}
